import type { FeatureGroup } from '../../../../types';
import { DEVELOPMENT_FEATURE_GROUP } from '../group';

export const DEVELOPMENT_MEMBERSHIP_CARD_DESIGNER_FEATURE_GROUP: FeatureGroup = {
  guid: '3bf3330d-14e7-4be5-8a2c-1f49ac37ff00',
  name: 'development:membership-card-designer',
  description: 'Membership Card Designer development tool — author membership card layouts',
  product: 'app',
  parentGuid: DEVELOPMENT_FEATURE_GROUP.guid,
};
